import { parseResponseBody, prepareBody, requestSocketPromiseWithTimeout } from "./query";
import * as SERVICE from '../constants/service.types';

export const getListDeviceByStateWS = async (input) => {
    console.log('🚀 ~ getListDeviceByStateWS ~ input:', input);
    const response = await requestSocketPromiseWithTimeout(
        {
            appServiceType: SERVICE.LIST_DEVICE_BY_STATE,
            body: prepareBody(input),
        },
        {
            timeout: 10000,
        },
    );

    console.log(
        '🚀 ~ getListDeviceByStateWS ~ parseResponseBody(response):',
        parseResponseBody(response),
    );
    return parseResponseBody(response);
};